/**
 * OnDemand const symbols.
 * @constant
 * @type {Object}
 */


const ON_DEMAND = {
    CB_FN: 'cbfn',
    STATUS_BAR_DATA: 'statusBarData',
    ODR_GAMES: 'ODR_Games'
};


export {ON_DEMAND};